import { MutableRefObject, Dispatch, useEffect, SetStateAction, useState } from 'react';
import { createPostMessageEventHandler } from '../impl/postMessageEventHandler';

interface LookerPostMessageOpts {
  urlLoaded?: string;
  frameRef: MutableRefObject<HTMLIFrameElement>;
  setFrameHeight: Dispatch<SetStateAction<string>>;
  setFrameDataLoaded: Dispatch<SetStateAction<boolean>>;
}

export const useLookerPostMessage = ({
  urlLoaded,
  frameRef,
  setFrameHeight,
  setFrameDataLoaded,
}: LookerPostMessageOpts) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!urlLoaded) {
      return;
    }

    const handler = createPostMessageEventHandler(frameRef.current, setFrameHeight, setFrameDataLoaded, setError);

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  }, [urlLoaded, frameRef, setFrameHeight, setFrameDataLoaded, setError]);

  return [error];
};
